import { AiOutlineInfoCircle } from "react-icons/ai";

const InfoBox = ({ infoText }: { infoText: string }) => {
  return (
    <div className="mb-8 flex gap-2 items-start bg-gray-50 rounded-lg p-4 border border-gray-100">
      <AiOutlineInfoCircle
        className="text-primary flex-shrink-0"
        fontSize={20}
      />
      <p className="text-sm text-primary">{infoText}</p>
    </div>
  );
};

export default InfoBox;
